export const activeClientStatuses = ['prospect', 'client'] as const
export const clientStatuses = [...activeClientStatuses, 'archived', 'deleted'] as const
export type ClientStatusEnum = (typeof clientStatuses)[number]

export interface ClientStatusDto {
   status: ClientStatusEnum
   displayName: string
   displayOrder: number
}

export const allClientStatuses: ClientStatusDto[] = [
   {
      status: 'client',
      displayName: 'Client',
      displayOrder: 2,
   },
   {
      status: 'prospect',
      displayName: 'Prospect',
      displayOrder: 1,
   },
   {
      status: 'archived',
      displayName: 'Archived',
      displayOrder: 3,
   },
   {
      status: 'deleted',
      displayName: 'Deleted',
      displayOrder: 4,
   },
]

